




















































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { RawLocation } from 'vue-router';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';

export default defineComponent({
  components: {
    AppLink,
    AppIcon,
    AppRectButton,
  },
  props: {
    sidePaddingSize: {
      type: String,
      default: 'px-4',
    },
    title: {
      type: String,
      default: null,
    },
    titleAlign: {
      type: String as PropType<'left' | 'center'>,
      default: 'left',
    },
    subtitle: {
      type: String,
      default: null,
    },
    isVerticalSubtitle: {
      type: Boolean,
      default: false,
    },
    noXMargin: {
      type: Boolean,
      default: false,
    },
    noRule: {
      type: Boolean,
      default: false,
    },
    moreLinkText: {
      type: String,
      default: null,
    },
    moreLinkTo: {
      type: [String, Object] as PropType<RawLocation>,
      default: null,
    },
    alwaysMoreButton: {
      type: Boolean,
      default: false,
    },
    tinyLayout: {
      type: Boolean,
      default: false,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    btnBgWhite: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      sendEvent(props.gaPartsType, props.moreLinkTo, '一覧を見る');
    };
    return { sendGaEvent };
  },
});
